import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-modal',
  imports: [TranslateModule, RouterLink],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.css'
})
export class ModalComponent {
  showMembershipModal: boolean = false;

  ngOnInit(): void {
  }
  
  closeMembershipModal() {
    this.showMembershipModal = false;

    // خزّن إنه قفل المودال
    localStorage.setItem('membershipModalClosed', 'true');

    // إزالة الباك دروب لو لسه موجود
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.remove();
  }

}
